module.exports = __webpack_public_path__ + "static/media/remove.ea5a87b9.svg";